/**
 * Initialisation du SDK Firebase modulaire : Auth, Firestore (cache local
 * persistant), Storage et App Check (reCAPTCHA Enterprise).
 */
import { initializeApp } from 'firebase/app'
import { ReCaptchaEnterpriseProvider, initializeAppCheck, type AppCheck } from 'firebase/app-check'
import { browserLocalPersistence, connectAuthEmulator, getAuth, setPersistence } from 'firebase/auth'
import {
  connectFirestoreEmulator,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore'
import { connectStorageEmulator, getStorage } from 'firebase/storage'

const env = import.meta.env

export const app = initializeApp({
  apiKey: env.VITE_FIREBASE_API_KEY,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
  appId: env.VITE_FIREBASE_APP_ID,
})

export const useEmulators = env.VITE_USE_EMULATORS === 'true'

// App Check : avant tout appel aux autres services. Jeton de debug en local
// (à enregistrer dans la console Firebase, voir DEPLOY.md).
export let appCheck: AppCheck | null = null
const siteKey = env.VITE_RECAPTCHA_ENTERPRISE_SITE_KEY
if (siteKey) {
  if (env.DEV) globalThis.FIREBASE_APPCHECK_DEBUG_TOKEN = true
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(siteKey),
    isTokenAutoRefreshEnabled: true,
  })
}

export const auth = getAuth(app)
auth.languageCode = 'fr'
void setPersistence(auth, browserLocalPersistence)

// Cache local persistant : catalogue disponible instantanément et hors ligne.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
  ignoreUndefinedProperties: true,
})

export const storage = getStorage(app)

if (useEmulators) {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
  connectFirestoreEmulator(db, 'localhost', 8081)
  connectStorageEmulator(storage, 'localhost', 9199)
}
